import { useContext, useMemo } from 'react';
import { BorderColor, ManageSearch } from '@mui/icons-material';
import { AbilityContext } from 'components/Permissions/Can';
import { allAssessments, adminAssessments, assessments, testTakers, learningResources, linguisticLab, dashboard, app, users, childDevelopment, newsletters, tutorials } from "router/routes"
import { ReactComponent as HomeIcon } from 'assets/icons/Home.svg';
import { ReactComponent as UsersIcon } from 'assets/icons/Users.svg';
import { ReactComponent as TestTakersIcon } from 'assets/icons/Testtakers.svg';
import { ReactComponent as AssessmentsIcon } from 'assets/icons/Assessments.svg';
import { ReactComponent as ActiveAssessmentsIcon } from 'assets/icons/ActiveAssessments.svg';
import { ReactComponent as TranscriptionIcon } from 'assets/icons/Transcription.svg';
import { ReactComponent as VoiceLabIcon } from 'assets/icons/VoiceLab.svg';
import { ReactComponent as LabIcon } from 'assets/icons/Lab.svg';
import { ReactComponent as ChildDevelopmentIcon } from 'assets/icons/ChildDevelopment.svg';
import { ReactComponent as WhatNewsIcon } from 'assets/icons/WhatNews.svg';
import { ReactComponent as TutorialsIcon } from 'assets/icons/Tutorials.svg';
import { queryClient as qc } from 'keys';
import { useQuery } from '@tanstack/react-query';
import { getWatingToMarkingCountFetch } from 'store/middlewares/assessment.crud';

const useMenuItems = () => {
    const ability = useContext(AbilityContext)

    const watingForMarkingCount = useQuery({
        queryKey: [qc.watingForMarkingCount],
        queryFn: async () => {
            const { data } = await getWatingToMarkingCountFetch()
            return data
        }
    })

    const menuItems = useMemo(
        () => [
            {
                index: 0,
                id: 0,
                label: "בית",
                path: dashboard,
                icon: HomeIcon,
                cleanTestTaker: true,
                feature: "dashboard"
            },
            {
                index: 1,
                id: 1,
                label: "משתמשים",
                path: users,
                icon: UsersIcon,
                feature: "users"
            },
            {
                index: 2,
                id: 2,
                label: ability.can("read", "student-label") ? "תלמידים" : "ילדים",
                path: testTakers,
                icon: TestTakersIcon,
                cleanTestTaker: true,

                feature: "test-takers"
            },
            {
                index: 3,
                id: 3,
                label: "אבחונים פעילים",
                path: allAssessments,
                icon: ActiveAssessmentsIcon,
                cleanTestTaker: true,

                feature: "all-assessments"
            },
            {
                index: 4,
                id: 4,
                label: "דוחות",
                path: assessments,
                icon: AssessmentsIcon,
                cleanTestTaker: true,

                feature: "assessments"
            },
            {
                index: 5,
                id: 5,
                label: "מערכת תעתוק",
                path: adminAssessments,
                icon: TranscriptionIcon,
                cleanTestTaker: true,
                badge: watingForMarkingCount.data,

                feature: "admin-assessments",
                subItems: [
                    {
                        index: 100,
                        id: 100,
                        label: "סימון מילים",
                        path: app.markingWordsAssessments,
                        feature: "admin-assessments",
                    },
                    {
                        index: 101,
                        id: 101,
                        label: "חיתוך אודיו",
                        path: app.audioCuttingAssessments,
                        feature: "audio-cutting",
                    },
                    {
                        index: 102,
                        id: 102,
                        label: "תעתוק",
                        path: app.transcriptionAssessments,
                        feature: "transcription"
                    }
                ]
            },
            {
                index: 6,
                id: 6,
                label: "המעבדה הקולית",
                path: learningResources,
                icon: VoiceLabIcon,
                feature: "voice-lab"
            },
            {
                index: 7,
                id: 7,
                label: "המעבדה הלשונית",
                path: linguisticLab,
                icon: LabIcon,
                feature: "linguistic-lab",

                subItems: [
                    {
                        index: 100,
                        id: 100,
                        label: "קריאות טקסטים",
                        path: app.textReadability,
                        icon: ManageSearch,
                        feature: "admin-assessments",
                    },
                    {
                        index: 101,
                        id: 101,
                        label: "קריאות מילים",
                        path: app.wordReadability,
                        icon: ManageSearch,
                        feature: "admin-assessments",
                    }
                ]
            },
            {
                index: 8,
                id: 8,
                label: "התפתחות הילד",
                path: childDevelopment,
                icon: ChildDevelopmentIcon,
                feature: "child-development",

                subItems: [
                    {
                        index: 101,
                        id: 101,
                        label: "נורמלטור",
                        path: app.normalizer,
                        icon: BorderColor,
                        feature: "child-development",
                    }
                ]
            },
            {
                index: 9,
                id: 9,
                label: "הדרכות",
                path: tutorials,
                icon: TutorialsIcon,
                feature: "tutorials"
            },
            {
                index: 10,
                id: 10,
                label: "מה חדש?",
                path: newsletters,
                icon: WhatNewsIcon,
                feature: "newsletter"
            }
        ], [watingForMarkingCount?.data]
    )

    return menuItems
}

export default useMenuItems